// @ts-nocheck

import { matchPath } from 'react-router-dom';

import { clearMyMatchModeMatchIds } from '../../actions/mymatch';
import { RouterActionTypes } from '../../types/actions/router';
import { RoutePatterns } from '../../types/routes';
import { type HandlerProps } from '../synchronousMiddleware';

export const handledActionTypes = [RouterActionTypes.ROUTE_HAS_CHANGED];

const routerMiddlewareHandler = ({ store: { dispatch }, action }: HandlerProps) => {
  if (~handledActionTypes.indexOf(action.type)) {
    const { type, payload } = action;

    if (type === RouterActionTypes.ROUTE_HAS_CHANGED) {
      const { pathname: actionPayloadPathname } = payload ?? {};

      if (!matchPath(actionPayloadPathname, RoutePatterns.MATCH)) {
        dispatch(clearMyMatchModeMatchIds());
      }
    }
  }
};

export default routerMiddlewareHandler;
